import * as RoutePathConstants from '../../../constants/RoutePathConstants'
import personalCenter from './views/personal-center'
import personalDetail from './views/personal-detail'
import personalInformation from './views/personal-information'
import myInsuranceRecord from './views/components/my-insurance-record'
import myStoredValueRecord from './views/components/my-stored-value-record'
import newDetection from './views/newDetection/newDetection'
import completionModification from './views/completion-modification/completion-modification'
import preInspectionRecord from './views/preInspectionRecord/preInspectionRecord'
import completionRecord from './views/completionRecord/completionRecord'
import routerCenter from './router-center'

export default [
  {
    path: RoutePathConstants.COMPLETION_MODIFICATION,
    name: 'completionModification',
    component: completionModification
  },
  {
    path: RoutePathConstants.COMPLETION_RECORD,
    name: 'completionRecord',
    component: completionRecord
  },
  {
    path: RoutePathConstants.NEW_DETECTION,
    name: 'newDetection',
    component: newDetection
  },
  {
    path: RoutePathConstants.PRE_INSPECTION_RECORD,
    name: 'preInspectionRecord',
    component: preInspectionRecord
  },
  {
    path: RoutePathConstants.WX_PERSONAL_CENTER,
    name: 'personalCenter',
    component: personalCenter
  },
  {
    path: RoutePathConstants.WX_PERSONAL_DETAIL,
    name: 'personalDetail',
    component: personalDetail
  },
  {
    path: RoutePathConstants.ROUTER_CENTER,
    name: 'routerCenter',
    component: routerCenter
  },
  {
    path: RoutePathConstants.MY_INSURANCE_RECORD,
    name: 'myInsuranceRecord',
    component: myInsuranceRecord
  },
  {
    path: RoutePathConstants.MY_STORED_VALUE_RECORD,
    name: 'myStoredValueRecord',
    component: myStoredValueRecord
  },
  {
    path: RoutePathConstants.PERSONAL_INFORMATION,
    name: 'personalInformation',
    component: personalInformation
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/routers.js